module.exports = __webpack_public_path__ + "img/00043.7b7eb919.webp";